import { Flex, Typography } from '@aloft/toolkit-sui';

import { clsx } from 'clsx';
import React from 'react';

import { registerTkv2ReferenceProperty } from '../../../../components/ReferenceBar/registerTkv2ReferenceProperty.ts';
import { useTkv2ReferenceBarEvents } from '../../../../components/ReferenceBar/useTkv2ReferenceBarEvents.ts';
import { getReferenceProperty } from '../../../utils/getReferenceProperty.ts';

type PropertyTabProps = {
  id: string;
  idx: number;
  active: boolean;
  onClick: () => void;
  disabled?: boolean;
  compSequence: string[];
};
export const PropertyTab = ({
  id,
  idx,
  active,
  onClick,
  disabled = false,
  compSequence,
}: PropertyTabProps) => {
  const refbar = (col: string) =>
    registerTkv2ReferenceProperty(getReferenceProperty(col, compSequence));
  const { onClick: handleClickForRefBar } = useTkv2ReferenceBarEvents();

  let propertyIconLabel = '';
  if (id === 'subject') {
    propertyIconLabel = 'SUB';
  } else if (id === 'subjectArv') {
    propertyIconLabel = 'SUB (ARV)';
  } else {
    propertyIconLabel = `C${idx}`;
  }

  const classes = ['property-tab'];
  if (disabled) classes.push('disabled');
  if (active) classes.push('selected');

  const handleClick = (e: React.MouseEvent) => {
    if (disabled) return;
    onClick();
    handleClickForRefBar(e);
  };

  return (
    <Flex
      className={clsx(classes)}
      alignItems="center"
      gap="0.25rem"
      flexShrink={0}
      onClick={handleClick}
      {...refbar(id)}
    >
      <Typography variant="h3" color={active ? 'surfaceAccent4' : 'textTertiary'}>
        {propertyIconLabel}
      </Typography>
    </Flex>
  );
}
